import { colorSystem } from '@/styles/theme'
import styled from 'styled-components'

export const BaseCell = styled.div`
  padding: 0 8px;
  border-bottom: 1px solid ${colorSystem.border.table};
  border-right: 1px solid ${colorSystem.border.table};
  display: flex;
  align-items: center;
`
